import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PixabayImagesService {
  constructor(private http: HttpClient) {}

  find_images({ query = '', image_type = 'photo' }) {
    const param: any = {
      q: query,
      image_type: image_type,
    };

    return this.http.get(`${environment.topicVizApi}/images/find`, {
      params: param,
    });
  }
}
